import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ModalBox from '../../common/modal/modal-box';
import TelegramButtonsRow from '../../common/telegram/telegram-buttons.row';
import { TelegramButton } from '../../interfaces/common';

interface ButtonsModalProps {
  open: boolean;
  onClose: () => void;
  buttons: TelegramButton[][];
  onButtonChange: (
    rowIndex: number,
    btnIndex: number,
    key: string,
    value: string,
  ) => void;
  onRemoveButtonsRow: (rowIndex: number) => void;
  onRemoveButton: (rowIndex: number, btnIndex: number) => void;
  onAddButtonsRow: () => void;
  onAddUrlButton: (buttonIndex: number) => void;
  onAddActionButton: (buttonIndex: number) => void;
}

const ButtonsModal: FC<ButtonsModalProps> = ({
  open,
  onClose,
  buttons,
  onButtonChange,
  onRemoveButtonsRow,
  onRemoveButton,
  onAddButtonsRow,
  onAddUrlButton,
  onAddActionButton,
}) => {
  const { t } = useTranslation();

  return (
    <ModalBox
      open={open}
      onClose={onClose}
      maxWidth="650px"
      sx={{
        height: 'max-content',
        maxHeight: '90%',
        overflow: 'auto',
        position: 'relative',
        p: '32px 44px',
      }}
    >
      <Button
        sx={{
          color: 'grey.1',
          backgroundColor: 'transparent',
          opacity: '0.8',
          position: 'absolute',
          top: '13px',
          right: '13px',
          minWidth: '24px',
          height: '24px',
          width: '24px',
          '&:hover': { color: 'grey.1', backgroundColor: 'transparent' },
        }}
      >
        <CloseIcon
          onClick={onClose}
          sx={{
            fontSize: '16px',
          }}
        />
      </Button>
      <Stack>
        <Stack>
          {buttons.map((row, rowIndex) => (
            <TelegramButtonsRow
              key={'buttons-row-' + rowIndex}
              urlExtended={true}
              buttons={row}
              onRemoveRow={() => {
                onRemoveButtonsRow(rowIndex);
              }}
              showAddActionButton
              onRemoveButton={(buttonIndex) => {
                onRemoveButton(rowIndex, buttonIndex);
              }}
              onAddNewUrlButton={() => {
                onAddUrlButton(rowIndex);
              }}
              onAddNewActionButton={() => {
                onAddActionButton(rowIndex);
              }}
              onButtonChange={(buttonIndex, key, value) => {
                onButtonChange(rowIndex, buttonIndex, key, value);
              }}
              rowIndex={rowIndex}
            />
          ))}
        </Stack>
        <Button
          sx={{
            color: 'green.2',
            fontSize: '14px',
            fontWeight: '600',
            backgroundColor: 'grey.13',
            border: 'none',
            borderRadius: '4px',
            padding: '8px',
            mt: '24px',
            height: '36px',
            ':hover': { border: 'none', backgroundColor: 'grey.13' },
          }}
          disabled={buttons.length > 4}
          onClick={onAddButtonsRow}
        >
          {t('telegramButtons.addRow')} +
        </Button>
        <Stack>
          <Button
            className="brightGreen"
            sx={{
              height: '56px',
              maxWidth: '280px',
              width: '100%',
              m: '16px auto',
            }}
            onClick={onClose}
          >
            {t('common.save')}
          </Button>
        </Stack>
      </Stack>
    </ModalBox>
  );
};

export default ButtonsModal;
